import styled from '@emotion/styled';

export const IdleStateWrapper = styled.div`
  height: 124px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
`;

export const UploaderHeading = styled.h2`
  margin: 0 0 8px 0;
  color: #7f8287;
  font-size: 1.8rem;
  line-height: 2.1rem;
`;

export const UploaderLink = styled.button`
  padding: 0;
  color: #5000b9;
  font-weight: 700;
`;

export const UploaderLabel = styled.div`
  color: #7f8287;
  font-size: 1.4rem;
  line-height: 1.6rem;
  opacity: 0.7;
`;
